/* eslint-disable */

// Do not edit directly, this file was auto-generated.

export type ThemeColor = {
  "contrast": string,
  "brandIndigo": string,
  "brandWhite": string,
  "backgroundBase": string,
  "backgroundLayer1": string,
  "backgroundLayer2": string,
  "neutralBackgroundBase": string,
  "neutralBackgroundHover": string,
  "neutralBackgroundDown": string,
  "neutralBackgroundSubdued": string,
  "accentBackgroundBase": string,
  "accentBackgroundHover": string,
  "accentBackgroundDown": string,
  "accentBackgroundSubdued": string,
  "accentSubtleBackgroundBase": string,
  "accentSubtleBackgroundHover": string,
  "accentSubtleBackgroundDown": string,
  "accentSubtleBackgroundSubdued": string,
  "negativeBackgroundBase": string,
  "negativeBackgroundHover": string,
  "negativeBackgroundDown": string,
  "negativeBackgroundSubdued": string,
  "contentBase": string,
  "contentSecondary": string,
  "contentSubdued": string,
  "contentDisabled": string,
  "contentNeutral": string,
  "contentWhite": string,
  "accentContentBase": string,
  "accentContentHover": string,
  "accentContentDown": string,
  "accentContentSubdued": string,
  "accentContentContrast": string,
  "negativeContentBase": string,
  "negativeContentHover": string,
  "negativeContentDown": string,
  "negativeContentSubdued": string,
  "borderBase": string,
  "borderSubdued": string,
  "shadowBase": string,
  "outlineBase": string,
  "plainContentBase": string,
  "plainBackgroundBase": string,
  "successContentBase": string,
  "successBackgroundBase": string,
  "errorContentBase": string,
  "errorBackgroundBase": string,
  "errorBorderBase": string,
  "errorShadowBase": string,
  "warningContentBase": string,
  "warningBackgroundBase": string,
  "infoContentBase": string,
  "infoBackgroundBase": string,
  "red": {
    "0": string,
    "5": string,
    "10": string,
    "20": string,
    "30": string,
    "40": string,
    "50": string,
    "60": string,
    "70": string,
    "80": string,
    "90": string,
    "95": string,
    "99": string,
    "100": string
  },
  "pink": {
    "0": string,
    "5": string,
    "10": string,
    "20": string,
    "30": string,
    "40": string,
    "50": string,
    "55": string,
    "60": string,
    "70": string,
    "80": string,
    "90": string,
    "95": string,
    "99": string,
    "100": string
  },
  "purple": {
    "0": string,
    "5": string,
    "10": string,
    "20": string,
    "30": string,
    "40": string,
    "50": string,
    "60": string,
    "70": string,
    "80": string,
    "90": string,
    "95": string,
    "99": string,
    "100": string
  },
  "violet": {
    "0": string,
    "5": string,
    "10": string,
    "20": string,
    "30": string,
    "40": string,
    "45": string,
    "50": string,
    "60": string,
    "70": string,
    "80": string,
    "90": string,
    "95": string,
    "99": string,
    "100": string
  },
  "indigo": {
    "0": string,
    "5": string,
    "10": string,
    "20": string,
    "30": string,
    "40": string,
    "50": string,
    "60": string,
    "70": string,
    "80": string,
    "90": string,
    "95": string,
    "99": string,
    "100": string
  },
  "blue": {
    "0": string,
    "5": string,
    "10": string,
    "20": string,
    "30": string,
    "40": string,
    "50": string,
    "55": string,
    "60": string,
    "70": string,
    "80": string,
    "90": string,
    "95": string,
    "99": string,
    "100": string
  },
  "cyan": {
    "0": string,
    "5": string,
    "10": string,
    "20": string,
    "30": string,
    "40": string,
    "50": string,
    "55": string,
    "60": string,
    "70": string,
    "80": string,
    "90": string,
    "95": string,
    "99": string,
    "100": string
  },
  "teal": {
    "0": string,
    "5": string,
    "10": string,
    "20": string,
    "30": string,
    "40": string,
    "50": string,
    "60": string,
    "65": string,
    "70": string,
    "80": string,
    "90": string,
    "95": string,
    "99": string,
    "100": string
  },
  "green": {
    "0": string,
    "5": string,
    "10": string,
    "20": string,
    "30": string,
    "40": string,
    "50": string,
    "55": string,
    "60": string,
    "70": string,
    "80": string,
    "90": string,
    "95": string,
    "99": string,
    "100": string
  },
  "grass": {
    "0": string,
    "5": string,
    "10": string,
    "20": string,
    "30": string,
    "40": string,
    "50": string,
    "60": string,
    "70": string,
    "80": string,
    "90": string,
    "95": string,
    "99": string,
    "100": string
  },
  "yellow": {
    "0": string,
    "5": string,
    "10": string,
    "20": string,
    "30": string,
    "40": string,
    "50": string,
    "60": string,
    "70": string,
    "80": string,
    "90": string,
    "95": string,
    "99": string,
    "100": string
  },
  "orange": {
    "0": string,
    "5": string,
    "10": string,
    "20": string,
    "30": string,
    "40": string,
    "50": string,
    "60": string,
    "70": string,
    "80": string,
    "90": string,
    "95": string,
    "99": string,
    "100": string
  },
  "gray": {
    "0": string,
    "5": string,
    "10": string,
    "20": string,
    "30": string,
    "40": string,
    "50": string,
    "60": string,
    "70": string,
    "80": string,
    "90": string,
    "95": string,
    "99": string,
    "100": string,
    "105": string
  },
  "white": string,
  "black": string,
  "avatarBackground": string,
  "avatarForeground": string,
  "iconBase": string,
  "iconHover": string,
  "iconDown": string,
  "iconSubdued": string,
  "switcherTrackBackground": string,
  "toggleSwitchTrackBackground": string,
  "toggleSwitchButtonBackground": string,
  "navigationTabsContent": string,
  "navigationTabsActive": string,
  "navigationTabsHover": string,
  "linkSecondaryContentBase": string,
  "linkSecondaryContentHover": string,
  "asidePanelBackground": string,
  "asidePanelSeparator": string,
  "asidePanelShadow": string,
  "inputBackground": string,
  "inputBorder": string,
  "popoverBackground": string,
  "popoverBackgroundHover": string,
  "projectSwitcherDefault": string,
  "projectSwitcherDisabled": string,
  "projectSwitcherHome": string,
  "skeletonLoaderBackground": string,
  "skeletonLoaderBackgroundAccent": string,
  "compareTableHighlight": string,
  "compareTableDiffIns": string,
  "compareTableDiffDel": string,
  "compareTableDiffUp": string,
  "compareTableDiffDown": string,
  "tooltipFixedRowBackground": string,
  "tooltipRowBackgroundHover": string,
  "toolbarBorder": string,
  "scrollbarTrack": string,
  "scrollbarThumb": string,
  "zoomAreaBackgroundBase": string,
  "keyShortcut": {
    "blackBase": string,
    "blackBackground": string,
    "whiteBase": string,
    "whiteBackground": string,
    "themedBase": string,
    "themedBackground": string,
    "invertedBase": string,
    "invertedBackground": string
  },
  "markBackground": string,
  "markContent": string,
  "syntax": {
    "foreground": string,
    "background": string,
    "punctuation": string,
    "operator": string,
    "comment": string,
    "shebang": string,
    "keyword": string,
    "key": string,
    "property": string,
    "string": string,
    "templateString": string,
    "tripleQuotedString": string,
    "scalar": string,
    "number": string,
    "boolean": string,
    "regex": string,
    "variable": string,
    "null": string,
    "builtin": string,
    "className": string,
    "function": string,
    "coord": string,
    "diff": string,
    "inserted": string,
    "deleted": string
  }
};

export const light: ThemeColor = {
  "contrast": "#141414",
  "brandIndigo": "#5b69c2",
  "brandWhite": "#ffffff",
  "backgroundBase": "#f1f1f4",
  "backgroundLayer1": "#ffffff",
  "backgroundLayer2": "#fafafa",
  "neutralBackgroundBase": "#ffffff",
  "neutralBackgroundHover": "#e3e5e8",
  "neutralBackgroundDown": "#f1f1f4",
  "neutralBackgroundSubdued": "#f1f1f4",
  "accentBackgroundBase": "#5832ab",
  "accentBackgroundHover": "#6d40cb",
  "accentBackgroundDown": "#5832ab",
  "accentBackgroundSubdued": "#6d40cb",
  "accentSubtleBackgroundBase": "#f8eeff",
  "accentSubtleBackgroundHover": "#f8eeff",
  "accentSubtleBackgroundDown": "#f8eeff",
  "accentSubtleBackgroundSubdued": "#f8eeff",
  "negativeBackgroundBase": "#cf364c",
  "negativeBackgroundHover": "#b4233d",
  "negativeBackgroundDown": "#cf364c",
  "negativeBackgroundSubdued": "#ff858a",
  "contentBase": "#141414",
  "contentSecondary": "#68717a",
  "contentSubdued": "#9098a0",
  "contentDisabled": "#d1d5d8",
  "contentNeutral": "#ffffff",
  "contentWhite": "#ffffff",
  "accentContentBase": "#5832ab",
  "accentContentHover": "#6d40cb",
  "accentContentDown": "#8351e6",
  "accentContentSubdued": "#6d40cb",
  "accentContentContrast": "#452786",
  "negativeContentBase": "#cf364c",
  "negativeContentHover": "#b4233d",
  "negativeContentDown": "#cf364c",
  "negativeContentSubdued": "#ff858a",
  "borderBase": "#d1d5d8",
  "borderSubdued": "#e3e5e8",
  "shadowBase": "#d1d5d8",
  "outlineBase": "#4382e9",
  "plainContentBase": "#68717a",
  "plainBackgroundBase": "#f1f1f4",
  "successContentBase": "#256c24",
  "successBackgroundBase": "#ebf5e9",
  "errorContentBase": "#b4233d",
  "errorBackgroundBase": "#ffedec",
  "errorBorderBase": "#ffa2a5",
  "errorShadowBase": "#ff858a",
  "warningContentBase": "#d1a521",
  "warningBackgroundBase": "#fdf1dc",
  "infoContentBase": "#005dbb",
  "infoBackgroundBase": "#eff2ff",
  "red": {
    "0": "#340f12",
    "5": "#451017",
    "10": "#55111b",
    "20": "#761224",
    "30": "#96172f",
    "40": "#b4233d",
    "50": "#cf364c",
    "60": "#e54e5e",
    "70": "#f76873",
    "80": "#ff858a",
    "90": "#ffa2a5",
    "95": "#ffc1c1",
    "99": "#ffdad9",
    "100": "#ffedec"
  },
  "pink": {
    "0": "#2a122f",
    "5": "#38153f",
    "10": "#45174f",
    "20": "#5f1c6e",
    "30": "#7a258c",
    "40": "#9332a8",
    "50": "#aa43c1",
    "55": "#a942c0",
    "60": "#bf58d5",
    "70": "#d171e5",
    "80": "#e18bf1",
    "90": "#eda7f8",
    "95": "#f5c4fd",
    "99": "#fadbff",
    "100": "#fdeeff"
  },
  "purple": {
    "0": "#1c163b",
    "5": "#221b50",
    "10": "#272065",
    "20": "#322c8e",
    "30": "#4039b5",
    "40": "#5248d7",
    "50": "#6758f3",
    "60": "#806bff",
    "70": "#9980ff",
    "80": "#b197ff",
    "90": "#c8b0ff",
    "95": "#ddc9ff",
    "99": "#ecdeff",
    "100": "#f6efff"
  },
  "violet": {
    "0": "#211438",
    "5": "#2a194c",
    "10": "#331d5f",
    "20": "#452786",
    "30": "#5832ab",
    "40": "#6d40cb",
    "45": "#7747db",
    "50": "#8351e6",
    "60": "#9965fb",
    "70": "#ae7bff",
    "80": "#c393ff",
    "90": "#d5acff",
    "95": "#e6c7ff",
    "99": "#f1ddff",
    "100": "#f8eeff"
  },
  "indigo": {
    "0": "#181a30",
    "5": "#1d2140",
    "10": "#22284f",
    "20": "#2c376f",
    "30": "#39478e",
    "40": "#4958aa",
    "50": "#5c6ac2",
    "60": "#717cd7",
    "70": "#8990e7",
    "80": "#a1a5f2",
    "90": "#b9bafa",
    "95": "#d1d0fe",
    "99": "#e4e3ff",
    "100": "#f2f1ff"
  },
  "blue": {
    "0": "#0f1b34",
    "5": "#0b2346",
    "10": "#072a58",
    "20": "#003a7b",
    "30": "#004b9d",
    "40": "#005dbb",
    "50": "#1d6fd5",
    "55": "#357be3",
    "60": "#4382e9",
    "70": "#6595f8",
    "80": "#86a9ff",
    "90": "#a6bdff",
    "95": "#c5d3ff",
    "99": "#dde4ff",
    "100": "#eff2ff"
  },
  "cyan": {
    "0": "#0e1d27",
    "5": "#0e2633",
    "10": "#0e2e3f",
    "20": "#0c4058",
    "30": "#0e5271",
    "40": "#1b6589",
    "50": "#2f779f",
    "55": "#4086ae",
    "60": "#488bb2",
    "70": "#639ec4",
    "80": "#80b1d3",
    "90": "#9fc4e0",
    "95": "#bfd8ec",
    "99": "#d8e7f4",
    "100": "#ecf3fa"
  },
  "teal": {
    "0": "#0d1f1c",
    "5": "#0d2824",
    "10": "#0c302c",
    "20": "#0b433d",
    "30": "#0e564f",
    "40": "#1a6961",
    "50": "#2c7d73",
    "60": "#439086",
    "65": "#439288",
    "70": "#5da39a",
    "80": "#79b6ad",
    "90": "#99c9c1",
    "95": "#badbd6",
    "99": "#d5eae6",
    "100": "#eaf5f3"
  },
  "green": {
    "0": "#0f1f0a",
    "5": "#10290d",
    "10": "#11320f",
    "20": "#144513",
    "30": "#1a581a",
    "40": "#256c24",
    "50": "#368033",
    "55": "#499243",
    "60": "#4c9345",
    "70": "#64a75c",
    "80": "#80b977",
    "90": "#9ecc95",
    "95": "#bdddb6",
    "99": "#d7ebd2",
    "100": "#ebf5e9"
  },
  "grass": {
    "0": "#1a1e00",
    "5": "#1e2700",
    "10": "#223000",
    "20": "#2c4200",
    "30": "#375500",
    "40": "#466900",
    "50": "#587c00",
    "60": "#6d8f00",
    "70": "#84a223",
    "80": "#9cb54a",
    "90": "#b6c872",
    "95": "#cfda9e",
    "99": "#e3e9c4",
    "100": "#f1f4e2"
  },
  "yellow": {
    "0": "#261b00",
    "5": "#2f2300",
    "10": "#372b00",
    "20": "#493b00",
    "30": "#5c4c00",
    "40": "#6f5e00",
    "50": "#837100",
    "60": "#998400",
    "70": "#af9700",
    "80": "#c5aa0b",
    "90": "#d9be51",
    "95": "#ead388",
    "99": "#f5e4b6",
    "100": "#fbf2db"
  },
  "orange": {
    "0": "#291900",
    "5": "#332100",
    "10": "#3d2800",
    "20": "#513700",
    "30": "#664800",
    "40": "#7c5900",
    "50": "#926b00",
    "60": "#a77e00",
    "70": "#bd9100",
    "80": "#d1a521",
    "90": "#e3ba58",
    "95": "#f1d08d",
    "99": "#f9e3b9",
    "100": "#fdf1dc"
  },
  "gray": {
    "0": "#141414",
    "5": "#1b1c1d",
    "10": "#292b2d",
    "20": "#373c40",
    "30": "#474d53",
    "40": "#575f67",
    "50": "#68717a",
    "60": "#7a848e",
    "70": "#9098a0",
    "80": "#a5acb2",
    "90": "#bbc0c5",
    "95": "#d1d5d8",
    "99": "#e3e5e8",
    "100": "#f1f1f4",
    "105": "#fafafa"
  },
  "white": "#ffffff",
  "black": "#000000",
  "avatarBackground": "#f1f1f4",
  "avatarForeground": "#575f67",
  "iconBase": "#9098a0",
  "iconHover": "#68717a",
  "iconDown": "#68717a",
  "iconSubdued": "#9098a0",
  "switcherTrackBackground": "#bbc0c5",
  "toggleSwitchTrackBackground": "#f1f1f4",
  "toggleSwitchButtonBackground": "#ecdeff",
  "navigationTabsContent": "#141414",
  "navigationTabsActive": "#5832ab",
  "navigationTabsHover": "#5832ab",
  "linkSecondaryContentBase": "#e6c7ff",
  "linkSecondaryContentHover": "#f1ddff",
  "asidePanelBackground": "#331d5f",
  "asidePanelSeparator": "#452786",
  "asidePanelShadow": "#f1f1f4",
  "inputBackground": "#ffffff",
  "inputBorder": "#00000000",
  "popoverBackground": "#ffffff",
  "popoverBackgroundHover": "#e3e5e8",
  "projectSwitcherDefault": "#ffffff",
  "projectSwitcherDisabled": "#bbc0c5",
  "projectSwitcherHome": "#7a848e",
  "skeletonLoaderBackground": "#e3e5e8",
  "skeletonLoaderBackgroundAccent": "#d1d5d8",
  "compareTableHighlight": "#fbf2db",
  "compareTableDiffIns": "#badbd6",
  "compareTableDiffDel": "#ffc1c1",
  "compareTableDiffUp": "#439288",
  "compareTableDiffDown": "#cf364c",
  "tooltipFixedRowBackground": "#e3e5e8",
  "tooltipRowBackgroundHover": "#f8eeff",
  "toolbarBorder": "#d1d5d8",
  "scrollbarTrack": "#f1f1f4",
  "scrollbarThumb": "#bbc0c5",
  "zoomAreaBackgroundBase": "#7a848e",
  "keyShortcut": {
    "blackBase": "#474d53",
    "blackBackground": "#000000",
    "whiteBase": "#d1d5d8",
    "whiteBackground": "#ffffff",
    "themedBase": "#d1d5d8",
    "themedBackground": "#ffffff",
    "invertedBase": "#474d53",
    "invertedBackground": "#000000"
  },
  "markBackground": "#fdf1dc",
  "markContent": "#a77e00",
  "syntax": {
    "foreground": "#333333",
    "background": "#ffffff",
    "punctuation": "#999999",
    "operator": "#9a6e3a",
    "comment": "#708090",
    "shebang": "#708090",
    "keyword": "#0077aa",
    "key": "#990055",
    "property": "#990055",
    "string": "#669900",
    "templateString": "#669900",
    "tripleQuotedString": "#669900",
    "scalar": "#669900",
    "number": "#990055",
    "boolean": "#990055",
    "regex": "#ee9900",
    "variable": "#ee9900",
    "null": "#990055",
    "builtin": "#669900",
    "className": "#dd4a68",
    "function": "#dd4a68",
    "coord": "#999999",
    "diff": "#999999",
    "inserted": "#669900",
    "deleted": "#dd4a68"
  }
};

export const dark: ThemeColor = {
  "contrast": "#ffffff",
  "brandIndigo": "#5b69c2",
  "brandWhite": "#ffffff",
  "backgroundBase": "#000000",
  "backgroundLayer1": "#141414",
  "backgroundLayer2": "#1b1c1d",
  "neutralBackgroundBase": "#292b2d",
  "neutralBackgroundHover": "#373c40",
  "neutralBackgroundDown": "#141414",
  "neutralBackgroundSubdued": "#141414",
  "accentBackgroundBase": "#5832ab",
  "accentBackgroundHover": "#6d40cb",
  "accentBackgroundDown": "#7747db",
  "accentBackgroundSubdued": "#452786",
  "accentSubtleBackgroundBase": "#452786",
  "accentSubtleBackgroundHover": "#211438",
  "accentSubtleBackgroundDown": "#211438",
  "accentSubtleBackgroundSubdued": "#211438",
  "negativeBackgroundBase": "#96172f",
  "negativeBackgroundHover": "#b4233d",
  "negativeBackgroundDown": "#b4233d",
  "negativeBackgroundSubdued": "#96172f",
  "contentBase": "#f1f1f4",
  "contentSecondary": "#7a848e",
  "contentSubdued": "#68717a",
  "contentDisabled": "#474d53",
  "contentNeutral": "#292b2d",
  "contentWhite": "#f1f1f4",
  "accentContentBase": "#7747db",
  "accentContentHover": "#8351e6",
  "accentContentDown": "#9965fb",
  "accentContentSubdued": "#452786",
  "accentContentContrast": "#c393ff",
  "negativeContentBase": "#96172f",
  "negativeContentHover": "#b4233d",
  "negativeContentDown": "#b4233d",
  "negativeContentSubdued": "#96172f",
  "borderBase": "#373c40",
  "borderSubdued": "#000000",
  "shadowBase": "#000000",
  "outlineBase": "#4382e9",
  "plainContentBase": "#7a848e",
  "plainBackgroundBase": "#1b1c1d",
  "successContentBase": "#80b977",
  "successBackgroundBase": "#144513",
  "errorContentBase": "#ff858a",
  "errorBackgroundBase": "#340f12",
  "errorBorderBase": "#96172f",
  "errorShadowBase": "#b4233d",
  "warningContentBase": "#d1a521",
  "warningBackgroundBase": "#513700",
  "infoContentBase": "#86a9ff",
  "infoBackgroundBase": "#003a7b",
  "red": {
    "0": "#ffedec",
    "5": "#ffdad9",
    "10": "#ffc1c1",
    "20": "#ffa2a5",
    "30": "#ff858a",
    "40": "#f76873",
    "50": "#e54e5e",
    "60": "#cf364c",
    "70": "#b4233d",
    "80": "#96172f",
    "90": "#761224",
    "95": "#55111b",
    "99": "#451017",
    "100": "#340f12"
  },
  "pink": {
    "0": "#fdeeff",
    "5": "#fadbff",
    "10": "#f5c4fd",
    "20": "#eda7f8",
    "30": "#e18bf1",
    "40": "#d171e5",
    "50": "#bf58d5",
    "55": "#a942c0",
    "60": "#aa43c1",
    "70": "#9332a8",
    "80": "#7a258c",
    "90": "#5f1c6e",
    "95": "#45174f",
    "99": "#38153f",
    "100": "#2a122f"
  },
  "purple": {
    "0": "#f6efff",
    "5": "#ecdeff",
    "10": "#ddc9ff",
    "20": "#c8b0ff",
    "30": "#b197ff",
    "40": "#9980ff",
    "50": "#806bff",
    "60": "#6758f3",
    "70": "#5248d7",
    "80": "#4e46dd",
    "90": "#4039b5",
    "95": "#322c8e",
    "99": "#272065",
    "100": "#1c163b"
  },
  "violet": {
    "0": "#f8eeff",
    "5": "#f1ddff",
    "10": "#e6c7ff",
    "20": "#d5acff",
    "30": "#c393ff",
    "40": "#ae7bff",
    "45": "#9965fb",
    "50": "#8351e6",
    "60": "#7747db",
    "70": "#6d40cb",
    "80": "#5832ab",
    "90": "#452786",
    "95": "#331d5f",
    "99": "#2a194c",
    "100": "#211438"
  },
  "indigo": {
    "0": "#f2f1ff",
    "5": "#e4e3ff",
    "10": "#d1d0fe",
    "20": "#b9bafa",
    "30": "#a1a5f2",
    "40": "#8990e7",
    "50": "#717cd7",
    "60": "#5c6ac2",
    "70": "#4958aa",
    "80": "#39478e",
    "90": "#2c376f",
    "95": "#22284f",
    "99": "#1d2140",
    "100": "#181a30"
  },
  "blue": {
    "0": "#eff2ff",
    "5": "#dde4ff",
    "10": "#c5d3ff",
    "20": "#a6bdff",
    "30": "#86a9ff",
    "40": "#6595f8",
    "50": "#4382e9",
    "55": "#357be3",
    "60": "#1d6fd5",
    "70": "#005dbb",
    "80": "#004b9d",
    "90": "#003a7b",
    "95": "#072a58",
    "99": "#0b2346",
    "100": "#0f1b34"
  },
  "cyan": {
    "0": "#ecf3fa",
    "5": "#d8e7f4",
    "10": "#bfd8ec",
    "20": "#9fc4e0",
    "30": "#80b1d3",
    "40": "#639ec4",
    "50": "#488bb2",
    "55": "#4086ae",
    "60": "#2f779f",
    "70": "#1b6589",
    "80": "#0e5271",
    "90": "#0c4058",
    "95": "#0e2e3f",
    "99": "#0e2633",
    "100": "#0e1d27"
  },
  "teal": {
    "0": "#eaf5f3",
    "5": "#d5eae6",
    "10": "#badbd6",
    "20": "#99c9c1",
    "30": "#79b6ad",
    "40": "#5da39a",
    "50": "#439086",
    "60": "#2c7d73",
    "65": "#23736a",
    "70": "#1a6961",
    "80": "#0e564f",
    "90": "#0b433d",
    "95": "#0c302c",
    "99": "#0d2824",
    "100": "#0d1f1c"
  },
  "green": {
    "0": "#ebf5e9",
    "5": "#d7ebd2",
    "10": "#bdddb6",
    "20": "#9ecc95",
    "30": "#80b977",
    "40": "#64a75c",
    "50": "#4c9345",
    "55": "#499243",
    "60": "#368033",
    "70": "#256c24",
    "80": "#1a581a",
    "90": "#144513",
    "95": "#11320f",
    "99": "#10290d",
    "100": "#0f1f0a"
  },
  "grass": {
    "0": "#f1f4e2",
    "5": "#e3e9c4",
    "10": "#cfda9e",
    "20": "#b6c872",
    "30": "#9cb54a",
    "40": "#84a223",
    "50": "#6d8f00",
    "60": "#587c00",
    "70": "#466900",
    "80": "#375500",
    "90": "#2c4200",
    "95": "#223000",
    "99": "#1e2700",
    "100": "#1a1e00"
  },
  "yellow": {
    "0": "#fbf2db",
    "5": "#f5e4b6",
    "10": "#ead388",
    "20": "#d9be51",
    "30": "#c5aa0b",
    "40": "#af9700",
    "50": "#998400",
    "60": "#837100",
    "70": "#6f5e00",
    "80": "#5c4c00",
    "90": "#493b00",
    "95": "#372b00",
    "99": "#2f2300",
    "100": "#261b00"
  },
  "orange": {
    "0": "#fdf1dc",
    "5": "#f9e3b9",
    "10": "#f1d08d",
    "20": "#e3ba58",
    "30": "#d1a521",
    "40": "#bd9100",
    "50": "#a77e00",
    "60": "#926b00",
    "70": "#7c5900",
    "80": "#664800",
    "90": "#513700",
    "95": "#3d2800",
    "99": "#332100",
    "100": "#291900"
  },
  "gray": {
    "0": "#f1f1f4",
    "5": "#e3e5e8",
    "10": "#d1d5d8",
    "20": "#bbc0c5",
    "30": "#a5acb2",
    "40": "#9098a0",
    "50": "#7a848e",
    "60": "#68717a",
    "70": "#575f67",
    "80": "#474d53",
    "90": "#373c40",
    "95": "#292b2d",
    "99": "#1b1c1d",
    "100": "#141414",
    "105": "#0b0c0d"
  },
  "white": "#ffffff",
  "black": "#000000",
  "avatarBackground": "#292b2d",
  "avatarForeground": "#9098a0",
  "iconBase": "#7a848e",
  "iconHover": "#7a848e",
  "iconDown": "#7a848e",
  "iconSubdued": "#575f67",
  "switcherTrackBackground": "#373c40",
  "toggleSwitchTrackBackground": "#292b2d",
  "toggleSwitchButtonBackground": "#5832ab",
  "navigationTabsContent": "#68717a",
  "navigationTabsActive": "#f1f1f4",
  "navigationTabsHover": "#f1f1f4",
  "linkSecondaryContentBase": "#ae7bff",
  "linkSecondaryContentHover": "#c393ff",
  "asidePanelBackground": "#292b2d",
  "asidePanelSeparator": "#141414",
  "asidePanelShadow": "#141414",
  "inputBackground": "#1b1c1d",
  "inputBorder": "#373c40",
  "popoverBackground": "#1b1c1d",
  "popoverBackgroundHover": "#292b2d",
  "projectSwitcherDefault": "#1b1c1d",
  "projectSwitcherDisabled": "#373c40",
  "projectSwitcherHome": "#68717a",
  "skeletonLoaderBackground": "#292b2d",
  "skeletonLoaderBackgroundAccent": "#373c40",
  "compareTableHighlight": "#261b00",
  "compareTableDiffIns": "#256c24",
  "compareTableDiffDel": "#761224",
  "compareTableDiffUp": "#4c9345",
  "compareTableDiffDown": "#e54e5e",
  "tooltipFixedRowBackground": "#292b2d",
  "tooltipRowBackgroundHover": "#211438",
  "toolbarBorder": "#1b1c1d",
  "scrollbarTrack": "#292b2d",
  "scrollbarThumb": "#373c40",
  "zoomAreaBackgroundBase": "#575f67",
  "keyShortcut": {
    "blackBase": "#575f67",
    "blackBackground": "#000000",
    "whiteBase": "#e3e5e8",
    "whiteBackground": "#ffffff",
    "themedBase": "#575f67",
    "themedBackground": "#000000",
    "invertedBase": "#e3e5e8",
    "invertedBackground": "#ffffff"
  },
  "markBackground": "#291900",
  "markContent": "#a77e00",
  "syntax": {
    "foreground": "#cccccc",
    "background": "#333333",
    "punctuation": "#999999",
    "operator": "#67cdcc",
    "comment": "#999999",
    "shebang": "#999999",
    "keyword": "#cc99cd",
    "key": "#f8c555",
    "property": "#f8c555",
    "string": "#7ec699",
    "templateString": "#7ec699",
    "tripleQuotedString": "#7ec699",
    "scalar": "#7ec699",
    "number": "#f08d49",
    "boolean": "#f08d49",
    "regex": "#7ec699",
    "variable": "#7ec699",
    "null": "#f08d49",
    "builtin": "#cc99cd",
    "className": "#f8c555",
    "function": "#f08d49",
    "coord": "#999999",
    "diff": "#999999",
    "inserted": "#7ec699",
    "deleted": "#dd4a68"
  }
};
